import type { UpdateSmartReportForm } from "#features/smart-reports/hooks/useUpdateSmartReportForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Radio, RadioGroup, Text } from "@hopper-ui/components";
import type { ControllerRenderProps } from "react-hook-form";

interface CadenceRadioGroupProps {
    field: ControllerRenderProps<UpdateSmartReportForm, "cadence">;
    dayOfWeek: string;
}

export const SmartReportCadenceRadioGroup = ({ field, dayOfWeek }: CadenceRadioGroupProps) => {
    const { tShared } = useSharedTranslation();

    const dayOfTheWeekLabel = tShared(`smartReports.dayOfWeek.${dayOfWeek.toLowerCase()}`);

    return (
        <RadioGroup
            {...field}
            orientation="vertical"
            aria-label={tShared("smartReports.cadenceLabel")}
            isFluid
            marginTop="inline-sm"
            border="neutral-weak"
            borderRadius="rounded-md"
            overflow="hidden"
            listProps={{ gap: 0 }}
        >
            <Radio
                value="BiWeekly"
                backgroundColor={field.value === "BiWeekly" ? "neutral-weakest" : undefined}
                backgroundColorHover="neutral-weakest"
                padding="inset-md"
                color={field.value === "BiWeekly" ? "core_samoyed" : "transparent"}
            >
                <Text color="neutral">
                    <Text size="sm" display="block">{tShared("smartReports.cadence.biWeekly")}</Text>
                    <Text size="xs" color="neutral-weakest">{tShared("smartReports.cadence.biWeeklyDescription", { dayOfWeek: dayOfTheWeekLabel })}</Text>
                </Text>
            </Radio>
            <Radio
                value="Monthly"
                borderTop="neutral-weak"
                backgroundColor={field.value === "Monthly" ? "neutral-weakest" : undefined}
                backgroundColorHover="neutral-weakest"
                padding="inset-md"
                color={field.value === "Monthly" ? "core_samoyed" : "transparent"}
            >
                <Text color="neutral">
                    <Text size="sm" display="block">{tShared("smartReports.cadence.monthly")}</Text>
                    <Text size="xs" color="neutral-weakest">{tShared("smartReports.cadence.monthlyDescription", { dayOfWeek: dayOfTheWeekLabel })}</Text>
                </Text>
            </Radio>
        </RadioGroup>
    );
};
